export enum ConsumerIdentityStatus {
  CI_UNSET, // Do not use, needed because of proto3 limitations
  CI_ACTIVATED,
  CI_BLOCKED,
  CI_DEACTIVATED,
}
